import type { IsoDate } from './iso-date';
import { toUtcMs } from './to-utc-ms';

export function daysBetween(from: IsoDate, to: IsoDate): number {
  return Math.round((toUtcMs(to) - toUtcMs(from)) / 86_400_000);
}
